<!-- vessel-details-dialog.component.html -->
<div class="dialog-header">
    <h6>Vessel Details</h6>
    <mat-icon color="warn" (click)="closeDialog()">close</mat-icon>
</div>

<div class="modalContainer">
    <div class="client-section">
        <div class="client-info">
            <span class="label" [ngClass]="{ 'dark-label': isDarkMode() }">Client Name : </span>
            <span class="value" style="word-wrap: break-word ; flex: shrink; margin-left: 5px;"> {{ data.clientName
                }}</span>
        </div>
        <span class="label" [ngClass]="{ 'dark-label': isDarkMode() }">Email : </span>
        <mat-chip-set class="email-chip">
            <mat-chip *ngFor="let mail of data.email" color="primary" selected>
                {{ mail }}
            </mat-chip>
        </mat-chip-set>
        <!-- <div class="client-info">
            <span class="label">Client Email : </span>
            <span class="value" style="word-wrap: break-word ; flex: shrink; margin-left: 5px;"> {{ data.email
                }}</span>
        </div> -->
    </div>

    <div class="label">Vessel List </div>

    <div *ngIf="data.vslList?.length > 0; else noData" class="table-container">
        <table class="vessel-table" [ngClass]="{ 'dark-table': isDarkMode() }">
            <thead>
                <tr>
                    <th style=" text-align: left;">Vessel Name</th>
                    <th>IMO Number</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let vsl of data.vslList">
                    <td style=" text-align: left;">{{ vsl.name }}</td>
                    <td>{{ vsl.imo_number }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template #noData>
        <p class="no-vessel">No Active Vessels Found</p>
    </ng-template>

    <ng-template #noData>
        <p class="no-vessel">No Active Vessels Found</p>
    </ng-template>

</div>